import { ErrorMessage } from '@hookform/error-message';
import { FieldErrors } from 'react-hook-form';
import { BsExclamationOctagonFill } from 'react-icons/bs';

export default function ErrorMsg({
  errors,
  error,
  name,
}: {
  errors?: FieldErrors;
  error?: any;
  name: string;
}) {
  return (
    <>
      <ErrorMessage
        errors={errors}
        name={name}
        render={({ message }) => {
          return (
            <p className='mb-2 mt-1 flex items-center gap-2'>
              <span className='text-[#F44]'>
                <BsExclamationOctagonFill />
              </span>{' '}
              {message}
            </p>
          );
        }}
      />
      {!!error && !!error[name]?.length && (
        <p className='mb-2 mt-1 flex items-center gap-2'>
          <span className='text-[#F44]'>
            <BsExclamationOctagonFill />
          </span>{' '}
          {error[name].join(' ')}
        </p>
      )}
    </>
  );
}
